import React from 'react';
import { SwiperSlide } from 'swiper/react';
import { Carousel, CarouselWrapper, CarouselArrowNavigation } from '$partials/base/carousel';
import ArticleListingItem from '$partials/items/article-listing-item';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/modules.d.ts').CuratedArticleCarousel}
 */

const CuratedArticleCarousel = ({
    heading,
    items
}) => {

    const swiperConfig = {
        slidesPerView: 'auto',
        spaceBetween: 0
    };

    const carouselItems = items?.filter(a => Boolean(a.article));

    return (

        <div className='module-article-carousel theme-light bg-main-background'>
            <div className='py-16 sm:py-40 md:py-48'>
                <Carousel swiperConfig={swiperConfig}>
                    <div className='flex flex-col gap-16 sm:gap-y-48 md:gap-24 w-full mx-auto'>
                        {/* Header with title and controls */}
                        <div className='layout-container layout-site-outer-padding w-full flex justify-between'>
                            {/* Title */}
                            {heading && (
                                <h2 className='type-style-2 text-main-text-primary w-full'>
                                    {heading}
                                </h2>
                            )}

                            {/* Controls */}
                            {carouselItems?.length > 3 && (
                                <div className='hidden sm:flex items-center justify-end gap-16'>
                                    <CarouselArrowNavigation />
                                </div>
                            )}
                        </div>

                        {/* Carousel */}
                        <div className='overflow-hidden w-full max-w-screen left-1/2 relative -translate-x-1/2'>
                            <div className='layout-container layout-site-outer-padding overflow-visible'>
                                <div className='col-wrapper'>
                                    <CarouselWrapper>
                                        {carouselItems?.map((article, index) => {
                                            return (
                                                <SwiperSlide
                                                    className='w-10/12 sm:w-5/12 md:w-4/12 flex'
                                                    key={article.article.id || index}>
                                                    <ArticleListingItem
                                                        className='col-padding'
                                                        isCarouselItem={true}
                                                        {...article?.article} />
                                                    {index < carouselItems?.length - 1 && (
                                                        <div className='shrink-0 w-[1px] h-full bg-main-border'></div>
                                                    )}
                                                </SwiperSlide>
                                            );
                                        })}
                                    </CarouselWrapper>
                                </div>
                            </div>
                        </div>
                    </div>
                </Carousel>
            </div>
        </div>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default CuratedArticleCarousel;
